import React, { useEffect, useRef, useState } from 'react';
import ErrorMessage from '../../../../errors/errorMessage';
import { Modal } from 'react-bootstrap';

function CustomCode({ data, showSectionChildModal, setShowSectionChildModal, handleSubmit, handleUpdate, error, close }) {
    const [code, setCode] = useState(``);
    const [lineHeights, setLineHeights] = useState([]);
    const [linesCount, setLinesCount] = useState(1);
    const textAreaRef = useRef(null);

    const calculateLineHeights = () => {
        const textArea = textAreaRef.current;
        const lines = code.split('\n');
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        const lineHeights = lines.map(line => {
            context.font = window.getComputedStyle(textArea).font;
            const lineWidth = context.measureText(line).width;
            console.log("lineWidth",lineWidth)
            const lineCount = Math.ceil(lineWidth / textArea.clientWidth) + 1;
            console.log("textArea.clientWidth",textArea.clientWidth)
            console.log("lineCount",lineCount)
            return lineCount * parseFloat(window.getComputedStyle(textArea).lineHeight);
        });
        setLineHeights(lineHeights);
    };

    useEffect(() => {
        if (data?.meta) {
            const parsedMeta = JSON.parse(data.meta);
            const initialCode = parsedMeta?.code ?? "";
            setCode(initialCode);
            setLinesCount(initialCode.split('\n').length);
        }
    }, [data?.meta]);

    // useEffect(() => {
    //     calculateLineHeights();
    // }, [code]);

    const handleChange = (e) => {
        setCode(e.target.value);
        setLinesCount(e.target.value.split('\n').length);
    };

    const handleSaveOrUpdate = (update, e) => {
        const formData = { code };
        if (update) {
            handleUpdate(formData, 'custom_code', e.target.dataset?.value);
        } else {
            handleSubmit(formData, 'custom_code');
        }
    };

    return (
        <Modal centered show={showSectionChildModal} onHide={close}>
            <div className="modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <span className='block-modal-headings'>Add Custom Code</span>
                        <button type="button" className="close" onClick={close} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form name="product_type" method="post" role="form">
                            <ErrorMessage error={error} />
                            <div className="form-group">
                                <label className="productlabels">Code</label>
                                <div className="code-text-area-main overflow-auto zaapGlobal-input mt-10px hidden-scroll h-50 d-flex align-items-start">
                                    {/* <div className='line-numbers'>
                                        {lineHeights.map((height, index) => (
                                            <div
                                                key={index}
                                                style={{ height: `${height}px` }}
                                            >
                                                {index + 1}
                                            </div>
                                        ))}
                                    </div> */}
                                    <textarea
                                        ref={textAreaRef}
                                        className=' transparent-textarea code-text-area'
                                        value={code}
                                        onChange={handleChange}
                                        placeholder="Enter your HTML/CSS code here..."
                                        rows={10}
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-column mt-20px gap-2'>
                                <small>Lines: {linesCount}</small>
                                <div className="d-flex gap-2 align-items-center justify-content-center">
                                    <button type="button" onClick={close} className="fs-12 w-50 mt-0 integration-btns integration-btn-grey">
                                        Cancel
                                    </button>
                                    <button type="button" onClick={(e) => handleSaveOrUpdate(data?.id ? true : false, e)} data-value={data?.id} className="fs-12 w-50 shadow-none project-blue-btn">
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default CustomCode;
